// extracted by mini-css-extract-plugin
export default {"button":"WT4nQs qdKc3_"};